export const load = () => ({
	h1: 'Get A Free Estimate ',
	title: 'Get A Free Estimate on Indow Window Inserts',
	description:
		'Get a free estimate on Indow window inserts and learn about how Indow inserts will save you money compared to window replacements.',
	showTitle: false,

	hideHeaderButton: true,
});
